import { CompetitionEntry } from '../types';

type EntryPaymentStatus = CompetitionEntry['paymentStatus'];

export function hasValidWcEntry(
  entries: Pick<CompetitionEntry, 'paymentStatus'>[],
  opts: { isFreeCompetition: boolean }
): boolean {
  if (opts.isFreeCompetition) {
    return entries.length > 0;
  }

  return entries.some(
    (e) => e.paymentStatus === 'paid' || e.paymentStatus === 'free'
  );
}

export function shouldBlockUnpaidWcAccess(opts: {
  entryFeeEnabled: boolean;
  tournamentLocked: boolean;
  entries: Pick<CompetitionEntry, 'paymentStatus'>[];
  isFreeCompetition: boolean;
}): boolean {
  if (!opts.entryFeeEnabled || opts.isFreeCompetition) {
    return false;
  }

  if (!opts.tournamentLocked) {
    return false;
  }

  return !hasValidWcEntry(opts.entries, { isFreeCompetition: opts.isFreeCompetition });
}

/** Raw enrollment row shape from get_user_competition_enrollment_data. */
export function hasValidWcEnrollmentEntry(
  entries: Array<{ payment_status?: EntryPaymentStatus | string }>,
  opts: { entryFeeEnabled: boolean }
): boolean {
  if (!opts.entryFeeEnabled) {
    return entries.length > 0;
  }

  return entries.some(
    (e) => e.payment_status === 'paid' || e.payment_status === 'free'
  );
}

export function isWcKickoffPassed(
  comp: {
    kickoff_finalized_at?: string | null;
    competition_type?: string;
  },
  firstGroupKickoff?: string | Date | null
): boolean {
  if (comp.competition_type !== 'worldcup') {
    return false;
  }

  if (comp.kickoff_finalized_at) {
    return true;
  }

  if (firstGroupKickoff) {
    return new Date(firstGroupKickoff).getTime() <= Date.now();
  }

  return false;
}
